import styles from '../About/About.module.css'
import Reveal from '../Reveal/Reveal'
import SectionTitle from '../SectionTitle/SectionTitle'
import { AppConstants } from '../../AppConstants'
import { InformationData } from '../../data/InformationData'

const About = () => {
    return (
        <section id='about' className={styles.about}>
            <Reveal>
                <div className='container'>
                    <SectionTitle>
                        {AppConstants.NavigationMenus.About} <span>{AppConstants.CommonWords.Me}</span>
                    </SectionTitle>
                    <div className="grid">
                        <div className={styles['about-img']}>
                            <img src={AppConstants.Images.AboutGif} alt="Mann Mendapara" loading="lazy" />
                        </div>
                        <div className={styles['about-content']}>
                            <h3 className={styles.border}>
                                {InformationData.Greetings.HiThere}
                            </h3>
                            <p>
                                {AppConstants.CommonWords.IM} <span className={styles.name}>{InformationData.FirstName}</span>{InformationData.AboutMe}
                            </p>
                        </div>
                    </div>
                </div>
            </Reveal>
        </section >
    )
}

export default About
